export default class EnterpriseCreaterRequest {
  public name;
  public email;
  public businessName;

  constructor(options) {
    this.name = options.name;
    this.email = options.email;
    this.businessName = options.businessName;
  }

  complete() {
    return this.name && this.email && this.businessName;
  }
}
